import styled from "styled-components";

export const ArrowIcon = styled.div`
  background-image: url("/assets/images/icon-arrow-black.png");
  width: 18px;
  height: 18px;
  margin-bottom: 7px;
`;
